import * as React from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
export const Error = () => (React.createElement("div", { id: "root__error", className: "sui-w-screen sui-h-screen sui-content-center" },
    React.createElement("div", { className: "sui-grid sui-gap-1 sui-text-center" },
        React.createElement("div", { className: "sui-mx-auto" },
            React.createElement("img", { src: "https://assets.homedepot-static.com/images/v1/oops.svg", alt: "", width: "700", height: "205" })),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2 sui-mb-3" },
            React.createElement(Typography, { variant: "h1", weight: "display" }, "WE'RE FIXING IT."),
            React.createElement(Typography, { variant: "h3" }, "We'll have this patched up as soon as possible")),
        React.createElement("div", null,
            React.createElement(Button, { href: "/" }, "Back to homepage")))));
